<!--
  @Description 产品版本设置
  @Date 2021-12-24
  @Author liushuo
-->
<template>
  <div>
    <vxe-grid
      ref="xTable"
      resizable
      :column-config="{ minWidth: '80px' }"
      :toolbar-config="tableToolbar"
      @toolbar-button-click="toolbarButtonClickEvent"
      :data="tableData"
      size="mini"
      :mouse-config="{ area: true }"
      highlight-hover-row
      highlight-current-row
      :height="tableHeight"
      :columns="gridColumns"
      :edit-rules="validRules"
      :edit-config="{
        trigger: 'dblclick',
        mode: 'cell',
        activeMethod: activeMethod
      }"
      :keyboard-config="{
        isArrow: true,
        isEnter: true,
        isTab: true,
        isClip: true,
        enterToTab: true,
        isEdit: true,
        editMethod: editMethod
      }"
      :cell-class-name="cellClassName"
      @menu-click="contextMenuClickEvent"
      :menu-config="{ body: { options: bodyMenus }, visibleMethod }"
    >
    </vxe-grid>
  </div>
</template>

<script>
export default {
  name: 'productVersion',
  props: {
    searchFormVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [],
      // 明细报错的索引
      errIndex: [],
      gridColumns: [],
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // tabel工具栏
      tableToolbar: {},
      // 右键菜单
      bodyMenus: [[]],
      // 校验
      validRules: {
        productionType: [
          { required: true, message: '请输入产品类型', trigger: 'change' },
          {
            min: 0,
            max: 10,
            message: '产品类型长度应在 0 到 10 个字符',
            trigger: 'change'
          }
        ],
        productionVersion: [
          { required: true, message: '请输入产品版本', trigger: 'change' },
          {
            min: 0,
            max: 16,
            message: '产品版本长度应在 0 到 16 个字符',
            trigger: 'change'
          }
        ],
        sort: [
          {
            validator: this.isInteger,
            validNumerical: this.validNumerical.nonNegative,
            trigger: 'change'
          }
        ]
      }
    }
  },
  created () {
    this.InitColumn()
    this.InitSettings()
    this.BindText()
    this.bindCombobox()
  },
  methods: {
    InitColumn () {
      this.gridColumns = [
        {
          type: 'seq',
          width: '50',
          className: 'seqErrorVaildClass',
          slots: {
            default: ({ row }) => {
              if (row.ifRepeat) {
                return [<el-tooltip class="tooltipItem"
                  effect="light" content={row.repeatText} placement="right" >
                  <div style="width: 100%; height: 100%">
                    <span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>
                  </div>
                </el-tooltip>]
              } else {
                return [<span>{this.$refs.xTable.getVTRowIndex(row) + 1}</span>]
              }
            }
          }
        },
        {
          field: 'delete', title: '删除',
          visible: this.$parent.Authority.edit,
          width: '50', align: 'center', slots: { default: ({ row }) => { return [<i id="vxeDelete" class="el-icon-delete-solid" onClick={() => { this.removeRowForTable(row, this.$refs.xTable, this.$data) }} ></i>] } }
        },
        {
          title: '产品类型', field: 'productionType',
          editRender: { name: "input", attrs: { disabled: true } },
        },
        {
          title: '产品版本', field: 'productionVersion',
          editRender: { name: "input" },
        },
        {
          title: '排序', field: 'sort',
          editRender: { name: "input" },
        }
      ]
    },
    InitSettings () {
      this.tableToolbar = {
        buttons: [
          { code: 'insertOne', name: '新增1行', disabled: !this.$parent.Authority.edit },
          { code: 'insertTen', name: '新增10行', disabled: !this.$parent.Authority.edit },
        ]
      }
    },
    async BindText () {
      if (!this.$parent.Authority.see) {
        this.$message.warning('您没有查看权限!')
        return
      }
      // sqlTitle 可选值 ['all' | 产品类型]
      const { data: res } = await this.$http.post('/Common/ProductVersionSet/list?sqlTitle=all')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
      }
      this.tableData = res.data
    },
    // 绑定下拉框
    async bindCombobox () {
      this.bodyMenus[0][0] = []
      const { data: res } = await this.$http.get('/Common/ProductVersionSet/select-item')
      if (!res.isSuccess) {
        return
      }

      // 产品类型
      this.bodyMenus[0] = res.data.filter((item) => item.code === 'ProductionType')
    },
    // table工具栏方法
    toolbarButtonClickEvent ({ code }) {
      switch (code) {
        case 'insertOne':
          this.insertEvent()
          break
        case 'insertTen':
          this.insertTenEvent()
          break
      }
    },
    // 新增一行
    insertEvent () {
      let record = {}
      this.$refs.xTable.insertAt(record, -1)
      // this.IfExistModify = true
    },
    // 新增10行
    insertTenEvent () {
      let record = {}
      for (var i = 0; i < 10; i++) {
        this.$refs.xTable.insertAt(record, -1)
      }
      // this.IfExistModify = true
    },
    // cell激活控制
    activeMethod ({ column }) {
      if (column.editRender?.attrs?.disabled === true) {
        return false
      }
      if (!this.$parent.Authority.edit) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod ({ row, column, $table }) {
      if (column.editRender?.attrs?.disabled === true) {
        return false
      }
      if (!this.$parent.Authority.edit) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
    // 右键打开菜单
    contextMenuClickEvent ({ menu }) {
      const areas = this.$refs.xTable.getCellAreas()

      areas.forEach(a => {
        for (let row of a.rows) {
          for (let column of a.cols) {
            if (column.property === 'productionType') {
              // 直接赋值列值
              row[column.property] = menu.name
            }
          }
        }
      })
    },
    // 快捷键
    visibleMethod ({ options, column }) {
      options.forEach(allRightMenuList => {
        allRightMenuList.forEach(menuItem => {
          if (!column || !this.$parent.Authority.edit) {
            // 若点击非表格的地方，则隐藏右键菜单
            menuItem.visible = false
          } else {
            menuItem.visible = column.property === 'productionType'
          }
        })
      })
      return true
    },
    // 修改
    async updateData () {
      this.validEnter().then(async result => {
        if (result) {
          this.httpUpdate()
        }
      })
    },
    // 验证
    async validEnter () {
      let flag = true
      this.errIndex = []
      // 重复行（产品类型、产品版本）
      this.repeatForTable(this.errIndex, this.$refs.xTable, ['productionType', 'productionVersion'])
      if (this.errIndex.length > 0) {
        this.$message.error('验证失败,请核对输入数据')
        return false
      }
      const errMap = await this.$refs.xTable.fullValidate(true).catch(errMap => errMap)
      if (errMap) {
        Object.values(errMap).forEach(errList => {
          errList.forEach(params => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          flag = false
        }
      }
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 发起修改请求
    async httpUpdate () {
      let tableData = [...this.tableData]
      let insertRecords = this.$refs.xTable.getInsertRecords()
      let removeRecords = this.$refs.xTable.getRemoveRecords()
      let updateRecords = this.$refs.xTable.getUpdateRecords()
      tableData = []
      for (let item of insertRecords) {
        tableData.push(item)
      }
      for (let item of removeRecords) {
        item.id = item.id > 0 ? 0 - item.id : item.id
        tableData.push(item)
      }
      for (let item of updateRecords) {
        tableData.push(item)
      }
      tableData = this.removeArrayNull(tableData)
      const { data: res } = await this.$http.post('/Common/ProductVersionSet/save', tableData)
      if (res.isSuccess) {
        this.$message.success(this.messageConfig.save.success)
        // this.IfExistModify = false
        this.BindText()
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    // 单元格设置样式,错误提示
    cellClassName ({ row, columnIndex }) {
      var a = this.errIndex.find(item => {
        return item._XID === row._XID && item.columnIndex === columnIndex
      })
      if (a) {
        return 'cell-valid'
      }
    },
  },
  computed: {
    tableHeight () {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
  }
}
</script>

<style lang="less">
// 工具栏高度调整
.vxe-toolbar.size--mini {
  display: flex;
  align-items: flex-start;
  height: 40px;
}
</style>
